<template>
  <base-card v-if="item">
    <base-heading class="mb-3 pb-1">
      {{ item.subject | striphtml }}
    </base-heading>
    <base-heading class="timestamp">
      <div class="mb-1">
        {{ item.start_date | nicedate('small') }}
        <span v-if="notSameDay">to {{ item.end_date | nicedate('small') }}</span>
      </div>
      <div>
        {{ item.start_date | nicedate('custom', 'h:mm A') }} to
        {{ item.end_date | nicedate('custom', 'h:mm A') }}
      </div>
    </base-heading>
    <base-text class="mb-4 mt-3 pb-1">
      {{ duration }}
    </base-text>
    <div
      class="intro"
      v-html="item.intro"
    />
  </base-card>
</template>

<script>
export default {
  name: 'AppointmentInvitationPreview',
  data() {
    return {

    };
  },
  computed: {
    item() {
      return this.$store.state.appointments.item;
    },
    notSameDay() {
      const start = new Date(this.item.start_date);
      const end = new Date(this.item.end_date);
      return start.toDateString() !== end.toDateString();
    },
    duration() {
      let duration = '';
      if (this.item.duration?.hours) {
        duration += `${this.item.duration.hours}h `;
      }
      duration += this.item.duration ? `${this.item.duration.minutes}m duration` : '--';
      return duration;
    },
  },
};
</script>
<style lang="scss" scoped>
.intro {
  border-radius: 5px;
  background-color: $gray-light;
  min-height: 357px;
  padding: 39px 20px;
}
.timestamp {
  color: $gray;
}
</style>
